const axiosClient = require('./axios');
const nodeFetchClient = require('./node-fetch');

const httpClient = axiosClient || nodeFetchClient;

if (!httpClient) {
  throw new Error('No http client package installed. Either install axios, node-fetch or supply your custom httpClient as described in the README.md file');
}

module.exports = httpClient;